import React from 'react'
import { getAuthorizeSubscription } from "utils/subscriptionProject"
import SubscriptionBlockWrapper from './SubscriptionBlockWrapper'
import { hasDashboardSubscription } from '../utils/subscriptionUtils'

const SubscriptionContent = ({ currentPlan, openProjectName, t }) => {
	const vatSub = hasDashboardSubscription(currentPlan?.subscriptions)
		? currentPlan.subscriptions
		: null
	const salesTaxSub = hasDashboardSubscription(currentPlan?.subscriptions_sales_tax)
		? currentPlan.subscriptions_sales_tax
		: null
	const ompSub = hasDashboardSubscription(currentPlan?.subscriptions_omp)
		? currentPlan.subscriptions_omp
		: null
	const eprSub = hasDashboardSubscription(currentPlan?.subscriptions_epr)
		? currentPlan.subscriptions_epr
		: null
	const invoiceSub = hasDashboardSubscription(currentPlan?.subscriptions_invoice)
		? currentPlan.subscriptions_invoice
		: null
	const authorizeSub = hasDashboardSubscription(getAuthorizeSubscription(currentPlan))
		? getAuthorizeSubscription(currentPlan)
		: null

	if (openProjectName === 'LTax' && ompSub) {
		return (
			<SubscriptionBlockWrapper
				type="omp"
				sub={ompSub}
				currentPlan={currentPlan}
				t={t}
			/>
		)
	}

	const hasBothSubscriptions = openProjectName === 'LTax' && vatSub && salesTaxSub

	if (hasBothSubscriptions) {
		return (
			<div className={'two-block_subscription-dashboard'}>
				<div className="first-subscription-item">
					<SubscriptionBlockWrapper
						type="vat"
						sub={vatSub}
						currentPlan={currentPlan}
						t={t}
					/>
				</div>
				<div className="second-subscription-item">
					<SubscriptionBlockWrapper
						type="sales tax"
						sub={salesTaxSub}
						currentPlan={currentPlan}
						t={t}
					/>
				</div>
			</div>
		)
	}

	return (
		<>
			{openProjectName === 'LTax' && vatSub && (
				<SubscriptionBlockWrapper
					type="vat"
					sub={vatSub}
					currentPlan={currentPlan}
					t={t}
				/>
			)}
			{openProjectName === 'LTax' && salesTaxSub && (
				<SubscriptionBlockWrapper
					type="sales tax"
					sub={salesTaxSub}
					currentPlan={currentPlan}
					t={t}
				/>
			)}
			{openProjectName === 'LEPR' && eprSub && (
				<SubscriptionBlockWrapper
					type="epr"
					sub={eprSub}
					currentPlan={currentPlan}
					t={t}
				/>
			)}
			{openProjectName === 'LInvoice' && invoiceSub && (
				<SubscriptionBlockWrapper
					type="invoice"
					sub={invoiceSub}
					currentPlan={currentPlan}
					t={t}
				/>
			)}
			{openProjectName === 'LAuthorize' && authorizeSub && (
				<SubscriptionBlockWrapper
					type="authorize"
					sub={authorizeSub}
					currentPlan={currentPlan}
					t={t}
				/>
			)}
		</>
	)
}

export default SubscriptionContent
